export class GenerateSeparationListReportInput {
    orderIds: number[];
    title: string;
}